import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectFinancementDispositif, selectRemboursementDispositif } from '@features/referentiel/features';
import { selectBaseUrl } from '@root/selectors/router.selectors';
import { AsyncPipe } from '@angular/common';
import { MenuFormComponent } from '@core/components/menu/components/menu-form.component';

@Component({
  standalone: true,
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    imports: [MenuFormComponent, AsyncPipe]
})
export class MenuComponent {

  @Input() menuDisplay: boolean = true;
  @Input() isLoggedIn: boolean = false;
  @Input() dispositifFinancement$ = this.store$.select(selectFinancementDispositif);
  @Input() dispositifRemboursement$ = this.store$.select(selectRemboursementDispositif);
  @Output() createDispositif: EventEmitter<any> = new EventEmitter();
  @Output() menuDisplayChange: EventEmitter<boolean> = new EventEmitter();

  url$ = this.store$.select(selectBaseUrl);

  constructor(
    private store$: Store
  ) { }

  menuClick(event: any) {
    this.createDispositif.emit(event);
  }

  closeMenu() {
    this.menuDisplayChange.emit(false);
  }

}
